import { setOutboundBinsForLine } from "services/utility/bins";
import { getBaseUom } from "services/utility/uoms";

export async function updateLineWithItem(item, line, record) {
  if (!item) {
    return line;
  }

  const { location } = record;
  // transfer the appropriate properties from the new inventory
  // item to the line item
  const newLine = {
    ...line,
    item,
    description: item.description,
    weightunit: item.weightUnit,
    volumeunit: item.volumeUnit,
    uom: getBaseUom(item.uoms),
    class: item.class,
    serials: [],
    onhand: item.onhand,
    relatedRecords: { item },
    itemDetails: {
      itemWeight: item.weight,
      itemVolume: item.volume,
      itemUoms: item.uoms,
      serialTracking: item.serialTracking,
      lotTracking: item.lotTracking,
      type: item.type,
    },
  };

  return await setOutboundBinsForLine(location, newLine);
}
